import { AuthService } from 'src/app/services/auth.service';
import { Console } from 'console';
import { SelectedVehicleService } from './../../../services/selectedVehicle.service';
import { DropUpLocaionModel } from './../../../models/DropUpLocaionModel';
import { SearchSectionService } from './../../../services/searchSection.service';
import { FindYourIdealCarMainModel, FindYourIdealCarModel } from './../../../models/Booking/FindYourIdealCarModel';

import { ModifyPickupModalComponent } from './../modify-pickup-modal/modify-pickup-modal.component';
import { BookingService } from 'src/app/services/booking.service';
import { RentalVehicleNotAvailableComponent } from './../rental-vehicle-not-available/rental-vehicle-not-available.component';
import { Branch } from './../../../models/Branch';
import { Component, OnInit, ChangeDetectorRef, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faMapMarkerAlt, faCalendarAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ThemePalette } from '@angular/material/core';
import { SearchService } from 'src/app/services/search.service';
import { VehicleReservationSearchParm } from './../../../models/VehicleReservationSearchParm';
import { DateFormatPipe } from './../../../common/pipes/DateFormatPipe';
import { Router } from '@angular/router';
//import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { flatMap } from 'rxjs/operators';
import { Vehicle } from 'src/app/models/Vehicle';
import { Subscription } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { VehicleReservationCaseDetailsModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import 'moment/locale/ar';


declare var $: any;
declare const svgToUrlImage: any;
declare const myTest: any;
@Component({
  selector: 'find-your-ideal-car',
  templateUrl: './find-your-ideal-car.component.html',
  styleUrls: ['./find-your-ideal-car.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class FindYourIdealCarComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedLang: any;
  currentLocation = { lat: 0, lng: 0 };
  faChevronDown = faChevronDown;
  searchForm: FormGroup;
  submitted = false;
  faMapMarkerAlt = faMapMarkerAlt;
  faCalendarAlt = faCalendarAlt;
  easyRent = false;
  address: Address = new Address();
  options = {
    types: []
    //componentRestrictions: {}
  };
  minPickUpDate: any = new Date();
  minDropOffDate: any;
  minTime: any;

  //Slide toggle
  color: ThemePalette = 'accent';
  checked = false;
  disabled = false;
  manualUpdate: boolean;
  faClock = faClock;
  searchModel: VehicleReservationSearchParm;
  returnLocations: DropUpLocaionModel[];
  selectedLocation;
  parameters: Array<string> = ["T"];
  vehicle: Vehicle;
  //@Input() selectedStepperIndex: number;
  _disableSearch: boolean = false;
  gracePeriod: number;
  subscriptions: Subscription[] = [];
  vehicleReservationCaseDetailsModel: VehicleReservationCaseDetailsModel;
  customer: any;

  @Input() set selectedStepperIndex(value: number) {
    if (value < 2) {
      this._disableSearch = false;
    }
    else {
      this._disableSearch = true;
    }
  }

  get disableSearch(): boolean {

    return this._disableSearch;

  }
  constructor(private bookingService: BookingService
    , private formBuilder: FormBuilder
    , protected cdr: ChangeDetectorRef
    , private searchService: SearchService
    , private _dateFormatPipe: DateFormatPipe
    , private router: Router
    , private dialog: MatDialog
    , private searchSectionService: SearchSectionService
    , private selectedVehicleService: SelectedVehicleService
    , private _notifications: NotificationsService
    , private translate: TranslateService
    , private _adapter: DateAdapter<any>
    , private authService: AuthService
  ) {


  }
  ngOnDestroy(): void {

    this.bookingService.updateFindYourIdealCar(null);
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }

  ngOnInit() {






    this.bookingService.vehicleReservationCaseDetailsModel.subscribe(res => {
      this.vehicleReservationCaseDetailsModel = res;
    })



    this.subscriptions.push(this.searchService.searchModel.subscribe(res => {
      let pickUpDate = new Date();
      let dropOffDate = new Date();

      //Prepare Data
      if (res != null) {
        if (res.StartDate != null) {
          pickUpDate = new Date(res.StartDate);
        }
        if (res.EndDate != null) {
          dropOffDate = new Date(res.EndDate);
        }
      }
      let scopeMinTime;
      this.subscriptions.push(this.searchService.reservationSettingModel.subscribe(res => {

        let gracePeriod = 0;
        if (res != null) {
          gracePeriod = res.bookingGracePeriodSettings.bookingGracePeriodInHours;
        }
        this.gracePeriod = gracePeriod;

        scopeMinTime = this.searchService.getFirstValidSartTime(pickUpDate, gracePeriod); //For the Jquery,

        //Get the first available time to book a car Today
        this.minTime = this.searchService.getFirstValidSartTime(dropOffDate, gracePeriod);

        this.minPickUpDate = this.searchService.getFirstValidSartDate(new Date(), this.gracePeriod);

      }))
      this.minDropOffDate = this.minPickUpDate;
      this.searchModel = res;


      this.selectedVehicleService.vehicle.subscribe(res => {

        this.vehicle = res;
        if (res != null) {
          this.getReturnLocations();
        }


      })
      // this.bookingService.vehicle.subscribe(res => {
      //   if (res != null) {

      //     this.vehicle = res;

      //   }
      // })





      this.selectedLocation = this.searchModel.DropUpLocationAgencyId;

      this.searchForm = this.formBuilder.group({
        pickUpLocation: [this.searchModel.FromAgencyName],
        dropOffLocation: [this.searchModel.DropUpLocationAgencyId, Validators.required],
        location: ['', Validators.required],
        PickUpDate: [this.searchModel.StartDate, Validators.required],
        PickUpTime: [this.searchModel.StartTimeString, Validators.required],
        dropUpDate: [this.searchModel.EndDate, Validators.required],
        dropUpTime: [this.searchModel.EndTimeString, Validators.required],
      });


      let currentDateMinTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Jquery,
      let scopeMinDroppOffTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html
      scopeMinTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Jquery,
      $(document).ready(function () {
        //Initilize the Time Picker for pick up and drop off
        $('#pickUpTime').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });
        $('#dropUpTime').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });



      });
    }));

    this.subscriptions.push(this.bookingService.dropOffLocation.subscribe(res => {

      if (res != null) {

        this.searchForm.controls.dropOffLocation.setValue(res.returnAgencyID);
      }
    }))



    // This is For changing language for the calendar
    this.selectedLang = JSON.parse(localStorage.getItem("lang"));
    switch (this.selectedLang.isoCode2) {
      case "en":
        this._adapter.setLocale('en-US');
        break;
      case "ar":
        this._adapter.setLocale('ar-ly');
        break;
      default:
        this._adapter.setLocale('en-US');
        break;
    }

    this.authService.loggedInCustomer.subscribe(res => {
      this.customer = res;
    })

  }
  getReturnLocations() {

    this.subscriptions.push(this.searchService.getDropUpLocationsByAgencyID(this.searchModel.AgencyID, '', false, this.vehicle.classID, this.vehicle.makeID, this.vehicle.modelID, this.vehicle.year, this.vehicle.vehicleID)
      .subscribe(res => {
        this.returnLocations = res;
        var pickUpLocationResoucedName = res.filter(a => a.returnAgencyID == this.searchModel.AgencyID)[0].agencyReturnLocationName;
        console.log(pickUpLocationResoucedName);
        //For adding the resource pickup location  name
        this.searchForm.controls["pickUpLocation"].setValue(pickUpLocationResoucedName);
      }))
  }
  ngAfterViewInit() {

    //Attach onChange Event
    $('#pickUpTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.PickUpTime.setValue($(e.target).val());
      //this.searchForm.controls.PickUpTime.setValue(dateText);
      //Check IF PickUp Time is greater than DropOff
      //this.validateDropOffTimeBasedOnPickUp($(e.target).val());
    });
    $('#dropUpTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.dropUpTime.setValue($(e.target).val());
      //this.searchForm.controls.PickUpTime.setValue(dateText);
    });

  }

  /** Validate DropOffTime Based on PickUpTime*/
  validateDropOffTimeBasedOnPickUp(pickUpTime: string) {

    let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
    let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);

    //IF They are on the same day, then we need to check
    //If the picktime greater than DropOff
    if (pickUpDate.getDate() == dropOffDate.getDate()) {
      let dropOffTime = this.searchForm.controls.dropUpTime.value;
      let compareResult = this.searchSectionService.comparePickUpAndDropOffTime(pickUpTime, dropOffTime);
      //If PickUp Is Greater than dropOff , then we will validate dropOff
      if (compareResult == 1) {
        $('#dropUpTime').timepicker('option', 'minTime', pickUpTime);
        this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
    }

  }


  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  onSubmit() {
    this.submitted = true;


    // stop here if form is invalid
    if (this.searchForm.errors != null) {
      return;
    }

    if (this.searchForm.controls["PickUpTime"].value > this.searchForm.controls["dropUpTime"].value && this.searchForm.controls["PickUpDate"].value == this.searchForm.controls["dropUpDate"].value) {

      this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res => {
        this._notifications.warn("<span>" + res + "</span>", null, {
          timeOut: 30000,
          showProgressBar: false,
          pauseOnHover: true,
          clickToClose: true,
          fade: true,
          actions: [{
            action: "Allow",
          }],
          icons: {
            error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
            warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
          }
        });
      })
      return;
    }


    let dropIpLocationTypeId = this.returnLocations.filter(a => a.returnAgencyID == this.selectedLocation)[0];
    let _searchModel = this.searchModel;
    _searchModel.StartDateString = this._dateFormatPipe.transform(this.searchForm.value['PickUpDate']);
    _searchModel.StartDate = this.searchForm.value['PickUpDate'];
    _searchModel.StartTimeString = this.searchForm.value['PickUpTime'];
    _searchModel.EndDateString = this._dateFormatPipe.transform(this.searchForm.value['dropUpDate']);
    _searchModel.EndDate = this.searchForm.value['dropUpDate'];
    _searchModel.EndTimeString = this.searchForm.value['dropUpTime'];
    _searchModel.FormatedLocation = this.address.formatted_address;
    _searchModel.ToAgencyID = this.selectedLocation;
    _searchModel.FromAgencyID = this.searchModel.AgencyID;
    _searchModel.DropOffLocationTypeID = dropIpLocationTypeId.agencyReturnLocationTypeID;
    // _searchModel.AgencyID = this.searchModel.DropUpLocationAgencyId;
    _searchModel.MakeID = this.vehicle.makeID;
    _searchModel.ModelID = this.vehicle.modelID;
    _searchModel.Year = this.vehicle.year;
    _searchModel.ClassID = this.vehicle.classID;
    _searchModel.VehicleID = this.vehicle.vehicleID;
    _searchModel.DropUpLocationAgencyId = this.selectedLocation;
    _searchModel.DropOffLocationID = this.selectedLocation;
    _searchModel.CustomerID = this.customer != null ? this.customer.customerID : null;

    if (this.vehicleReservationCaseDetailsModel.membershipModel != null) {
      _searchModel.MembershipID = this.vehicleReservationCaseDetailsModel.membershipModel.membershipID;
    }


    if (this.vehicleReservationCaseDetailsModel.campaignsReservationCaseModel != null) {
      _searchModel.CampaignID = this.vehicleReservationCaseDetailsModel.campaignsReservationCaseModel.campaignID;
    }


    if (!this.searchService.validateDropOffVSPickUp(new Date(_searchModel.StartDate), _searchModel.StartTimeString, new Date(_searchModel.EndDate), _searchModel.EndTimeString)) {
      this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res => {
        this._notifications.warn("<span>" + res + "</span>", null, {
          timeOut: 30000,
          showProgressBar: false,
          pauseOnHover: true,
          clickToClose: true,
          fade: true,
          actions: [{
            action: "Allow",
          }],
          icons: {
            error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
            warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
          }
        });
      })
      return;
    }










    this.subscriptions.push(this.bookingService.updateVehicleReservationSearchByAgency(_searchModel).subscribe(res => {



      if (res != null && res.isAvailable) {

        if (this.vehicle.pricingRuleID != res.pricingRuleID || this.vehicle.campaignID != res.campaignID || this.vehicle.membershipID != res.membershipID) {
          this.vehicle.pricingRuleID = res.pricingRuleID;
          this.vehicle.campaignID = res.campaignID;
          this.vehicle.membershipID = res.membershipID;
          this.selectedVehicleService.updateVehicle(this.vehicle);
        }
        this.searchService.cachedSearchModel(_searchModel);


        let _findYourIdealCarModel: FindYourIdealCarModel = {
          StartDateString: _searchModel.StartDateString,
          StartTimeString: _searchModel.StartTimeString,
          EndDateString: _searchModel.EndDateString,
          EndTimeString: _searchModel.EndTimeString,
          DurationUnitName: res.durationUnitName,
          PricingRuleID: res.pricingRuleID,
          TotalRentalPriceNewDuration: res.totalRentalPriceNewDuration,
          ToAgencyID: this.selectedLocation,
          DropOffLocationTypeID: dropIpLocationTypeId.agencyReturnLocationTypeID
        }
        let mainModel: FindYourIdealCarMainModel = {
          findYourIdealCarModel: _findYourIdealCarModel,
          searchModel: _searchModel
        }

        debugger

        console.log("🚀 ~ file: find-your-ideal-car.component.ts ~ line 424 ~ FindYourIdealCarComponent ~ this.subscriptions.push ~ res", res)
        this.searchService.updateSearchModel(_searchModel);
        this.bookingService.updateSearchModel(_searchModel);

        this.vehicle.durationUnitName = res.durationUnitName;
        this.vehicle.vehiclePrice = res.totalRentalPriceNewDuration;
        //this.selectedVehicleService.updateFindYourIdealCarVehicle(this.vehicle);

        this.ngOnDestroy();
        //this.bookingService.updateFindYourIdealCar(mainModel);
      }
      else if (res != null && res["msg"] == 'InvalidRentalPeriod') {

        this.RentalVehicleNotAvailable('NoAvailableRentalsThatMatchYourSearchCriteria');
      }
      else {
        this.RentalVehicleNotAvailable();
      }

    }, err => {
      this.RentalVehicleNotAvailable();
    }));



  }


  public handleAddressChange(address: Address) {

    this.currentLocation = {
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
    };
    this.address = address;
  }

  /*   addEvent(type: string, event: MatDatepickerInputEvent<Date>) {


      if (new Date(event.value).getDate() == new Date().getDate()) {


        this.searchForm.controls.PickUpTime.setValue(this.minTime);
      }
      else {
        let pickUpDate = new Date(event.value);
        //New DroppOff Date min Value (New PickUpDate +1)
        pickUpDate.setDate(pickUpDate.getDate() + 1);
        this.searchForm.controls.dropUpDate.setValue(pickUpDate);
        this.minDropOffDate = pickUpDate;

      }
    } */

  //Event handler when pickup datepicker changed
  addEvent(mode: number, type: string, event: MatDatepickerInputEvent<Date>) {


    //PickUp Date

    if (mode == 1) {
      let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);
      this.minDropOffDate = new Date(event.value);
      if (new Date(event.value).getDate() == new Date().getDate() && new Date(event.value).getDate() == dropOffDate.getDate()) {


        this.searchForm.controls.PickUpTime.setValue(this.minTime);

        //this.searchForm.controls.dropUpTime.setValue(this.minDroppOffTime);
      }
      else if (new Date(event.value).getDate() == new Date().getDate()) {

        this.searchForm.controls.PickUpTime.setValue(this.minTime);
      }
      else {
        if (new Date(event.value).getDate() == dropOffDate.getDate()) {

          let pickUpTime = this.searchForm.controls.PickUpTime.value;

          this.searchForm.controls.dropUpTime.setValue(pickUpTime);
        }
        //IF PickUp Date Greter than drop OFF
        else if (new Date(event.value) > dropOffDate) {
          this.searchForm.controls.dropUpDate.setValue(new Date(event.value));
          let pickUpTime = this.searchForm.controls.PickUpTime.value;
          let dropUpTime = this.searchForm.controls.dropUpTime.value;
          if (!this.searchService.validateTime(dropUpTime, pickUpTime)) {

            this.searchForm.controls.dropUpTime.setValue(pickUpTime);
          }
        }
        else {

        }
      }

    }
    //Drop Off Date
    else if (mode == 2) {
      let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
      if (new Date(event.value).getDate() == pickUpDate.getDate()) {
        let pickUpTime = this.searchForm.controls.PickUpTime.value;

        //this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
      else {


      }
    }
    this.ngAfterViewInit();



  }

  RentalVehicleNotAvailable(msg = null) {

    const dialogConfig = new MatDialogConfig();
    if (msg != null) {
      dialogConfig.data = {
        msg: msg
      }
    }

    this.dialog.open(RentalVehicleNotAvailableComponent, dialogConfig);
  }
}
